<template>
    <div>
        <div class="result-title">
            <span class="success-image" v-if="status === 'success'">
                <img src="/assets/icons/apply-success.png" alt="">
            </span>
            <span>{{ title }}</span>
        </div>
        <div v-if="statusText" class="result-status">
            当前状态：<span class="result-status-text">{{ statusText }}</span>
            <slot name="status-sub-text"></slot>
        </div>
        <div class="result-extra">
            <slot></slot>
        </div>
    </div>
</template>
<script>
export default {
    name: 'Result',
    props: {
        title: {
            type: String,
            default: ''
        },
        status: {
            type: String,
            default: 'success'
        },
        statusText:String
    }
}
</script>
<style scoped>
.result-title{
    font-weight: 500;
    font-size: 18px;
    color: #141414;
    display: flex;
    align-items: center;
    justify-content: flex-start;
}
.success-image{
    margin-right: 8px;
    img{
        width: 16px;
        height: 16px;
    }
}

.result-status{
    font-weight: 400;
    font-size: 14px;
    color: #999999;
    margin-top: 14px;
}

.result-status-text{
    background: #EDEDED;
    padding-left: 10px;
    padding-right: 10px;
    font-size: 14px;
    color: #141414;
    line-height: 20px;
    display: inline-block;
}

.result-extra{
    margin-top: 14px;
}
</style>
